module.exports = __webpack_public_path__ + "static/media/gi.88f5e250.svg";